import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints, fontWeights }: Theme) => ({
  root: {
    paddingTop: '2rem',
    paddingBottom: '2rem',
    [breakpoints.up('md')]: {
      paddingTop: '4rem',
      paddingBottom: '4rem',
    },
  },
  title: {
    margin: '0 0 2rem',
    fontSize: '1.75rem',
    fontWeight: fontWeights.medium,
    lineHeight: 1.35,
  },
  subtitle: {
    margin: '0 0 0.75rem',
    fontSize: '1.25rem',
    fontWeight: fontWeights.medium,
    lineHeight: 1.4,
  },
  text: {
    margin: '0 0 0.5rem',
    '&:last-of-type': {
      marginBottom: 0,
    },
  },
  list: {
    paddingLeft: '1.5rem',
    margin: 0,
    '& li': {
      marginBottom: '0.5rem',
    },
    '& li:last-child': {
      marginBottom: 0,
    },
  },
  img: {
    width: '100%',
    maxWidth: '20.375rem',
    margin: '2rem 0',
  },
  button: {
    marginTop: '2rem',
  },
}));
